import React, { useState } from 'react'
import AddNewGenderIdentity from './AddNewGenderIdentity';

const GenderIdentity = ({ data, setIsRecordSaved, patientID, ...props }) => {
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;

  const [isOpenGenderIdentity, setIsOpenGenderIdentity] = useState(false);
  const [genderIdentityData, setGenderIdentityData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddGenderIdentity = (item) => {
    if(!isViewAllowed) return;
    setGenderIdentityData(item)
    setIsOpenGenderIdentity(prev => !prev);
  }
  const CloseGenderIdentity = () => {
    setIsOpenGenderIdentity(false)
  }

  let PopupScreen = "";
  if (isOpenGenderIdentity) {
    PopupScreen = <AddNewGenderIdentity isOpenGenderIdentity={isOpenGenderIdentity} genderIdentityData={genderIdentityData} setIsRecordSaved={setIsRecordSaved} onClose={CloseGenderIdentity} patientID={patientID} // onDeleteGenderIdentity={DeleteGenderIdentity} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <div className='mx-2 mb-2'>
      {PopupScreen}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <p className='heading cursor-pointer user-select-none' onClick={handleToggleExpand}>Gender Identity</p>
        {data?.length > 0 ? null :
        <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddGenderIdentity({ PatientHistoryID: null })}>
          <i className="icon-dash-plus"></i>
        </div>}
      </div>
      <div className="d-flex gap-1 flex-column">
        {expandItems &&
          (data?.length > 0 ?
          data.map(item => (
            <div className="d-flex justify-content-between align-items-center">
              <p className={`text validate-color font-m cursor-pointer ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddGenderIdentity(item)}>{item.GenderIdentity} </p>
              {/* <p className='text'>10/04/2024 </p> */}
            </div>)) :
          <p className="text C9-light-clr fst-italic">No gender identity recorded</p>)}
      </div>
    </div>
  )
}

export default GenderIdentity